module.exports = __webpack_public_path__ + "img/head.e35eea7c.png";